import script from "./SiteParameterDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteParameterDisplay.vue?vue&type=script&setup=true&lang=js"

import "./SiteParameterDisplay.vue?vue&type=style&index=0&id=6c18566a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c18566a"]])

export default __exports__